import React, { useMemo } from "react"
import { formatPhoneNumber } from "../../shared/utils"
import { SlideOverHeader } from "../SlideOverHeader"
import { useSlideOver } from "../../useSlideOver"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"
import { useLazyCmsCollectionMap } from "../../../domain/CMS/useLazyCmsCollectionMap"

const formatWebsiteDestination = (url?: string): string | undefined => {
  if (!url) return undefined
  const lowerUrl = url.toLowerCase()
  return /^https?:\/\//.test(lowerUrl) ? lowerUrl : `http://${lowerUrl}`
}
interface ProfileCardProps {
  phoneNumberList: { number: string; phoneTypeDisplayId?: string | null }[]
  photoFileId?: string
  profileId: string
  profileName: string
  profileTagDisplayIds?: string[]
  profileType: string
  providerDesignationDisplayIds?: string[]
  websiteUrl?: string
  isManaged?: boolean
  isRegistered?: boolean
  status?: string // for practice
  providerStatusDisplayId?: string // for provider
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  phoneNumberList,
  photoFileId,
  profileId,
  profileName,
  profileTagDisplayIds,
  profileType,
  providerDesignationDisplayIds,
  websiteUrl,
  isManaged = false,
  isRegistered,
  status,
  providerStatusDisplayId,
}) => {
  const { cms: cmsContent } = useCMSReady([
    "common",
    "providerTagsMap",
    "providerDesignationsMap",
  ])
  const resolvedDesignationMap = useLazyCmsCollectionMap(
    "designationTypes",
    "providerDesignationsMap",
  )
  const { showProfileSidebar } = useSlideOver()
  const tagMap = useMemo(() => {
    return showProfileSidebar.practiceId
      ? cmsContent.practiceTagsMap
      : cmsContent.providerTagsMap
  }, [
    cmsContent.practiceTagsMap,
    cmsContent.providerTagsMap,
    showProfileSidebar.practiceId,
  ])

  const phonesData = useMemo(() => {
    if (phoneNumberList?.length === 1) {
      return phoneNumberList.map((phone) => {
        return formatPhoneNumber(phone.number || "")
      })
    } else {
      const contactTextMap: Record<string, string | undefined> = {
        office: cmsContent?.common?.office,
        mobile: cmsContent?.common?.mobile,
        "phone-mobile": cmsContent?.common?.mobile,
        "phone-office": cmsContent?.common?.office,
      }
      return phoneNumberList?.map((phone) => {
        const formatted = formatPhoneNumber(phone.number || "")
        const label = phone.phoneTypeDisplayId
          ? contactTextMap[phone.phoneTypeDisplayId]
          : undefined
        return label ? `${label}: ${formatted}` : formatted
      })
    }
  }, [cmsContent?.common?.mobile, cmsContent?.common?.office, phoneNumberList])

  return (
    <div className="flex flex-col gap-5">
      {/* TODO: add the rest of the practice header data  */}
      <SlideOverHeader
        data={{
          name: profileName,
          phones: phonesData || [],
          designations:
            providerDesignationDisplayIds?.map((displayId) => {
              return resolvedDesignationMap[displayId]
            }) || [],
          image: photoFileId,
          profileId: profileId,
          profileType: profileType,
          tags:
            profileTagDisplayIds?.map((displayId) => {
              // @ts-expect-error "should be defined"
              return tagMap?.[displayId]
            }) || [],
          websiteName: websiteUrl,
          websiteDestination: formatWebsiteDestination(websiteUrl),
          isManaged: isManaged,
          isRegistered: isRegistered,
          status: profileType === "practiceProfile" ? status : undefined,
          providerStatusDisplayId:
            profileType === "providerProfile"
              ? providerStatusDisplayId
              : undefined,
        }}
      />
    </div>
  )
}

export default ProfileCard
